import { nanoid } from 'nanoid';

import type { UploadedFont } from 'types/fonts';
import { parseFontMetadata } from 'common/fonts/parse-font-metadata';

export const getFontFileMetadata = async (file: File): Promise<UploadedFont> => ({
	...(await parseFontMetadata(await file.arrayBuffer(), file.name)),
	file,
	id: nanoid(4),
	fontType: 'custom',
	size: file.size,
});
